import * as React from 'react'

import { useRecoilSound } from '../../hooks/useRecoilSound'
import Button, { ButtonProps } from './Button'
import SVG from '../common/SVG'
import SoundOffButtonS from '../icons/SoundOffButtonS'
import SoundOnButtonS from '../icons/SoundOnButtonS'

export type ButtonSoundSProps = ButtonProps & {}

const soundOn = <SoundOnButtonS />
const soundOff = <SoundOffButtonS />

const ButtonSoundS: React.FC<ButtonSoundSProps> = ({ color, ...others }) => {
  const { sound, setSound } = useRecoilSound()
  const icon = sound ? soundOn : soundOff

  const handleClick = () => {
    setSound(!sound)
  }

  return (
    <>
      <Button variant="unstyled" minW="0" minH="0" w="30px" h="30px" display="flex" onClick={handleClick} {...others}>
        <SVG svg={icon} w="19px" h="14px" fill={color} stroke={color} />
      </Button>
    </>
  )
}

export default ButtonSoundS
